import { Component, Input, OnInit } from '@angular/core';
import { Deal } from 'app/models/dto/deal.model';
import {Select} from '@ngxs/store';
import {LenderUserState} from 'ng2-app/store/lender-user/lender-user/lender-user.state';
import {Observable} from 'rxjs';

@Component({
  selector: 'app-deal-status-display',
  templateUrl: './deal-status-display.component.html',
  styleUrls: ['./deal-status-display.component.scss']
})
export class DealStatusDisplayComponent implements OnInit {

  @Input() deal: Deal;
  @Select(LenderUserState.hasPermission('canSeeDealStatusRestrictions')) canSeeDealStatusRestrictions$: Observable<boolean>;

  statusFormatted: string;

  constructor() { }

  ngOnInit(): void {
    const statusOption = this.deal?.statusOptions.filter( opt => opt.value === this.deal?.status)[0];
    this.statusFormatted = statusOption?.display;
  }

}
